"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerBackend = void 0;
var backend_impl_js_1 = require("./backend-impl.js");
Object.defineProperty(exports, "registerBackend", { enumerable: true, get: function () { return backend_impl_js_1.registerBackend; } });
//# sourceMappingURL=backend.js.map